// extracted by mini-css-extract-plugin
module.exports = {"cardBox":"CompanyVisionCard_cardBox__XuNWR"};